import { getSelectedBG } from 'store/selectedBubble/reducer';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { getGlobal } from 'store';
import { Sprite, AnimatedSprite } from '@inlet/react-pixi';
import { getBGList } from 'store/resources';
import { CachedSprites } from 'lib/utils';
import { AnimatedSprite as AnimatedType } from 'pixi.js';

interface BackgroundProps {
  bgSpritesList: CachedSprites;
}

export const BackgroundComponent: FC<BackgroundProps> = ({ bgSpritesList }) => {
  const { height, width } = useSelector(getGlobal);
  const currentBGID = useSelector(getSelectedBG);
  const bgList = useSelector(getBGList);

  const currentBG = bgSpritesList[currentBGID] || { height, width };

  const imageAspect = currentBG.height / currentBG.width;
  const screenAspect = height / width;

  let imageHeight = height;
  let imageWidth = width;

  if (imageAspect > 1) {
    if (screenAspect > imageAspect) {
      imageHeight = height;
      imageWidth = height / imageAspect;
    } else {
      imageWidth = width;
      imageHeight = width * imageAspect;
    }
  } else {
    imageHeight = height;
    imageWidth = height / imageAspect;
  }

  return (
    <>
      {Object.values(bgSpritesList).map((b, id) => {
        if (!b.texture) {
          return null;
        }

        return b instanceof AnimatedType ? (
          <AnimatedSprite
            isPlaying
            textures={[b.texture]}
            key={bgList[id].id}
            alpha={bgList[id].id === currentBGID ? 1 : 0}
            height={imageHeight}
            width={imageWidth}
            position={[width / 2, height / 2]}
            anchor={0.5}
          />
        ) : (
          <Sprite
            key={bgList[id].id}
            alpha={bgList[id].id === currentBGID ? 1 : 0}
            texture={b.texture}
            height={imageHeight}
            width={imageWidth}
            position={[width / 2, height / 2]}
            anchor={0.5}
          />
        );
      })}
    </>
  );
};
